import { Component, OnInit } from '@angular/core';
import { DataStorageService } from '../../../data-storage.service';
import { AvailableComponents } from '../../../side-bar/enumAvailableComponents';
import { Datasim } from '../../../../models/Datasim';
import { PricingService } from '../../../pricing.service';
import { DatasimPrincing } from '../../../../models/DatasimPricing';
import { ApiService } from '../../../api.service';
import { isNumber } from 'util';

@Component({
  selector: 'app-datasim',
  templateUrl: './datasim.component.html',
  styleUrls: ['./datasim.component.scss']
})
export class DatasimComponent implements OnInit {
  private datasims:Array<Datasim>;
  private priceLists:Array<DatasimPrincing>;
  private options:Array<String>;
  constructor(
    public dataStorageService: DataStorageService,
    public api: ApiService,
    private pricing: PricingService
  ) {
    this.datasims = []
    pricing.getDatasimPriceList().then(data => {
      this.priceLists = data;
      this.options = this.priceLists.map(price => price.productOption)
    })
  }

  ngOnInit() {
    const element = document.getElementById('datasimSide');
    element.classList.add('active');
    this.dataStorageService.currentComponent = AvailableComponents['Datasim'];
  }

  ngOnDestroy() {
    const element = document.getElementById('datasimSide');
    element.classList.remove('active');
  }

  addDatasimClick() {
    var toAdddatasim = Datasim.fromPriceList(this.priceLists[0]);
    this.api.postDatasim(this.dataStorageService.currentState.offerID, toAdddatasim).then(datasim => {
      this.dataStorageService.currentState.datasims.push(datasim);
    })
  }

  removedatasimClick(index) {
    var datasim = this.dataStorageService.currentState.datasims[index]//
    this.api.deleteDatasim(this.dataStorageService.currentState.offerID, datasim.id).then( res => {
      this.dataStorageService.currentState.datasims.splice(index, 1)
    })
  }

  setValue(i: number, event: any, type:string, isParentCall=true) {
    // quantity, voice, type
    let currentDatasim = this.dataStorageService.currentState.datasims[i]

    if(type == 'type') {
      var newPrice = this.priceLists[this.options.indexOf(event.target.value)]
      currentDatasim.productOption = event.target.value
      currentDatasim.costMonthly = newPrice.costMonthly * currentDatasim.quantity
      if(currentDatasim.hasVoiceOption) {
        currentDatasim.costMonthly += DatasimPrincing.PRICE_VOICE_OPTION * currentDatasim.quantity
      }
    } else if (type == 'voice') {
      var newPrice = this.priceLists[this.options.indexOf(currentDatasim.productOption)]
      currentDatasim.hasVoiceOption = event.target.value == '1'
      currentDatasim.costUnique = newPrice.costUnique * currentDatasim.quantity
      currentDatasim.costMonthly = newPrice.costMonthly * currentDatasim.quantity
      if(currentDatasim.hasVoiceOption) {
        currentDatasim.costMonthly += DatasimPrincing.PRICE_VOICE_OPTION * currentDatasim.quantity
      }
    } else if (type == 'quantity') {
      let value = parseInt(event.target.value);
      currentDatasim.quantity = isNaN(value) ? 1 : value
      this.setValue(i, {target: {value: currentDatasim.productOption}}, 'type', false)
      this.setValue(i, {target: {value: currentDatasim.hasVoiceOption}}, 'voice', false)
    }

    if(isParentCall) {
      this.api.postDatasim(this.dataStorageService.currentState.offerID, currentDatasim)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/datasim/datasim.component.ts